import {
  addSeparators,
  formatNumberCompact,
} from '../../../utils/format-utils.js';

function D10Details({ data }) {
  return (
    <div style={{ marginTop: 20, width: 390 }}>
      <div style={{ fontWeight: 'bold', fontSize: 18, marginBottom: 10 }}>
        {formatNumberCompact(data.min)} - {formatNumberCompact(data.max)}
      </div>
      На основании анализа данных конкурентов в этой локации и городе в целом
    </div>
  );
}

export default D10Details;
